<template>
	<vx-card no-shadow card-border class="mt-1">
		<vs-list-item
			v-show="!show"
			:title="`${$t('Visit')} ${indexVisitPoint}`"
			:subtitle="validateProperty(visitPoint, 'init_hour') + ' - ' + validateProperty(visitPoint, 'end_hour')"
		>
			<template slot="avatar">
				<vs-avatar :color="colorAvatar(visitPoint)" icon-pack="feather" icon="icon-calendar" />
			</template>
			<div class="vx-row">
				<div class="vx-col w-full">
					<div class="flex flex-wrap items-center justify-end">
						<vs-button
							type="border"
							color="primary"
							icon-pack="feather"
							:icon="'icon-edit'"
							class="ml-auto"
							:title="$t('ManualData.FixErrorsHere')"
							@click="showInfo"
						></vs-button>
					</div>
				</div>
			</div>
		</vs-list-item>
		<transition name="slide-fade">
			<vx-card v-if="show" no-shadow>
				<template slot="actions">
					<span class="text-primary mb-2">
						<feather-icon
							icon="XSquareIcon"
							svgClasses="h-6 w-6"
							class="cursor-pointer"
							@click="show = false"
					/></span>
				</template>
				<div slot="no-body">
					<table style="width: 100%" class="border-collapse">
						<caption></caption>
						<tr>
							<th class="p-2 border border-solid d-theme-border-grey-light">
								{{ $t("Information") }}
							</th>
							<th class="p-2 border border-solid d-theme-border-grey-light">
								{{ $t("UploadFiles.Details") }}
							</th>
						</tr>
						<tr>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								<div class="flex items-center justify-between">
									<span>{{ $t("Resource") }}</span>
									<div v-for="(errorItem, index) in visitPoint.errorFound" :key="index">
										<feather-icon
											v-if="
												errorItem.absolute_path[1] === 'resource_id' &&
												visitPoint.resource_id === null
											"
											icon="AlertCircleIcon"
											svgClasses="h-5 w-5 text-danger hover:text-warning cursor-pointer"
											:title="
												errorItem.value +
												': ' +
												$t('Resource') +
												' ' +
												$t('Vehicles.VehicletNotFound.Text2')
											"
											@click="seeDetailInformation(tr)"
										/>
									</div>
								</div>
							</td>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ nameResource(visitPoint.resource_id) }}
							</td>
						</tr>
						<tr style="z-index: 590000">
							<td class="p-2 border border-solid d-theme-border-grey-light">
								<div class="flex items-center justify-between">
									<span>{{ $t("Activity") }}</span>
									<div v-for="(errorItem, index) in visitPoint.errorFound" :key="index">
										<feather-icon
											v-if="
												errorItem.absolute_path[1] === 'activity_id' &&
												visitPoint.activity_id === null
											"
											icon="AlertCircleIcon"
											svgClasses="h-5 w-5 text-danger hover:text-warning cursor-pointer"
											:title="
												errorItem.value +
												': ' +
												$t('Activity') +
												' ' +
												$t('Vehicles.VehicletNotFound.Text2')
											"
											@click="seeDetailInformation(tr)"
										/>
									</div>
								</div>
							</td>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								<span v-if="visitPoint.resource_id === null && visitPoint.activity_id === null">{{
									$t("ToAssignAnActivity")
								}}</span>
								<v-select
									v-else
									v-model="selectedActivity"
									v-validate="'required'"
									:clearable="false"
									:options="activityOptions"
									:disabled="visitPoint.resource_id === null"
								>
									<template v-slot:no-options="{search, searching}">
										<template v-if="searching">
											{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
										</template>
										<template v-else>
											{{ $t("NoResultsFound") }}
										</template>
									</template>
									<template #option="{label}">
										{{ label }}
									</template>
								</v-select>
							</td>
						</tr>
						<tr>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								<div class="flex items-center justify-between">
									<span>{{ $t("VisitPoint") }}</span>
									<div v-for="(errorItem, index) in visitPoint.errorFound" :key="index">
										<feather-icon
											v-if="
												errorItem.absolute_path[1] === 'visit_point_id' &&
												visitPoint.visit_point_id === null
											"
											icon="AlertCircleIcon"
											svgClasses="h-5 w-5 text-danger hover:text-warning cursor-pointer"
											:title="
												errorItem.value +
												': ' +
												$t('VisitPoint') +
												' ' +
												$t('Vehicles.VehicletNotFound.Text2')
											"
											@click="seeDetailInformation(tr)"
										/>
									</div>
								</div>
							</td>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								<span v-if="visitPoint.resource_id === null && visitPoint.visit_point_id === null">{{
									$t("ToAssignAVisitPoint")
								}}</span>
								<v-select
									v-else
									v-model="selectedVisitPoint"
									v-validate="'required'"
									:clearable="false"
									:options="visitPointOptions"
									:disabled="visitPoint.resource_id === null"
									:dir="$vs.rtl ? 'rtl' : 'ltr'"
								>
									<template v-slot:no-options="{search, searching}">
										<template v-if="searching">
											{{ $t("NoResultsFoundFor") + " " }}<em>{{ search }}</em>
										</template>
										<template v-else>
											{{ $t("NoResultsFound") }}
										</template>
									</template>
									<template #option="{idAndName}">
										{{ idAndName }}
									</template>
								</v-select>
							</td>
						</tr>
						<tr>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ $t("CompanyCreate.InitDate") }}
							</td>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ visitPoint.init_date }}
							</td>
						</tr>
						<tr>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ $t("CompanyCreate.EndDate") }}
							</td>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ visitPoint.end_date }}
							</td>
						</tr>
						<tr>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ $t("ResourceModule.Create.InitialHour") }}
							</td>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ visitPoint.init_hour }}
							</td>
						</tr>
						<tr>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ $t("ResourceModule.Create.FinalHour") }}
							</td>
							<td class="p-2 border border-solid d-theme-border-grey-light">
								{{ visitPoint.end_hour }}
							</td>
						</tr>
					</table>
				</div>
			</vx-card>
		</transition>
	</vx-card>
</template>

<script>
import vSelect from "vue-select";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import moduleUpload from "@/store/upload/moduleUpload.js";
import moduleOptimization from "@/store/optimization/moduleOptimization.js";

export default {
	components: {
		vSelect,
		VuePerfectScrollbar,
		flatPickr,
	},
	props: {
		visit_point_selected: {
			type: Object,
			default: () => {},
		},
		activityOptions: {
			type: Array,
			default: () => [],
		},
		visitPointOptions: {
			type: Array,
			default: () => [],
		},
		resourceOptions: {
			type: Array,
			default: () => [],
		},
		indexVisitPoint: {
			type: Number,
			default: () => 0,
		},
		activitySelected: {
			type: Object,
			default: () => {},
		},
		visitPointSelected: {
			type: Object,
			default: () => {},
		},
		resourceSelected: {
			type: Object,
			default: () => {},
		},
	},
	data() {
		return {
			isMounted: false,
			activePrompt: false,
			activitiesList: [],
			selectedActivity: {label: this.$t("Select"), value: null},
			selectedVisitPoint: {label: this.$t("Select"), value: null},
			selectedResource: {label: this.$t("Select"), value: null},
			show: false,
			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
		};
	},
	watch: {
		show(val) {
			if (val) {
				const foundAct = this.activityOptions.find((act) => act.value === this.visitPoint.activity_id);
				if (foundAct) {
					this.selectedActivity = foundAct;
				}
				const foundActVisitPoint = this.visitPointOptions.find(
					(act) => act.value === this.visitPoint.visit_point_id
				);
				if (foundActVisitPoint) {
					this.selectedVisitPoint = foundActVisitPoint;
				}
			}
		},
		resourceSelected(val) {
			this.selectedResource = val;
			this.show = false;
		},
		selectedActivity(activity) {
			this.visitPoint.activity_id = activity.value;
		},
		selectedVisitPoint(visitPoint) {
			this.visitPoint.visit_point_id = visitPoint.value;
		},
		selectedResource(resource) {
			this.visitPoint.resource_id = resource.value;
		},
	},
	computed: {
		visitPoint() {
			return this.visit_point_selected;
		},
		validateProperty() {
			return function (obj, propertyName) {
				if (Object.hasOwnProperty.call(obj, propertyName)) {
					return obj[propertyName];
				} else {
					return "";
				}
			};
		},
		colorAvatar() {
			return function (val) {
				return val.resource_id != null && val.activity_id != null && val.visit_point_id != null
					? "success"
					: "warning";
			};
		},
	},
	methods: {
		showInfo() {
			this.show = true;
		},
		nameResource(item) {
			let resource = this.resourceOptions.find((elem) => elem.value === item);
			if (resource) {
				let completeName = resource.idAndName;
				return completeName;
			} else {
				return item;
			}
		},
	},
	mounted() {
		this.isMounted = true;
	},
	created() {
		if (!moduleUpload.isRegistered) {
			this.$store.registerModule("moduleUpload", moduleUpload);
			moduleUpload.isRegistered = true;
		}
		if (!moduleOptimization.isRegistered) {
			this.$store.registerModule("moduleOptimization", moduleOptimization);
			moduleOptimization.isRegistered = true;
		}
	},
};
</script>

<style lang="scss" scoped>
#content-router-selection {
	height: 100%;
}
.scroll-area {
	margin: auto;
	width: 100%;
	min-height: 450px;
	max-height: 400px;
}
.content-form-create {
	width: 100%;
	min-height: 550px;
	max-height: 650px;
}
.slide-fade-enter-active {
	transition: all 0.3s ease;
}
.slide-fade-leave-active {
	transition: all 0.2s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
	transform: translateX(200px);
	opacity: 0;
}
</style>
